import { WithTooltip } from './WithTooltip';
import crownIcon from '/public/premium_icon_crown.svg';
import { useDiffitUserContext } from '../contexts/DiffitUserContext';
import Image from './Image';

export default function PremiumIconCrown({
  className = '',
  toolTipProps = { text: 'Premium', position: 'top', anchor: 'left' },
  wrapperClassName = '',
  hideTooltipForPaidUsers = true,
}) {
  const { hasActiveSubscription } = useDiffitUserContext();

  let finalizedTooltipProps = toolTipProps;
  if (hideTooltipForPaidUsers && hasActiveSubscription) {
    finalizedTooltipProps = {
      ...toolTipProps,
      text: undefined,
    };
  }

  return (
    <div className={wrapperClassName}>
      <WithTooltip {...finalizedTooltipProps}>
        <span className='py-1'>
          <Image src={crownIcon} alt='Premium Crown' className={`${className}`} />
        </span>
      </WithTooltip>
    </div>
  );
}
